import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { connect } from 'react-redux';
import { selectChangeImpactTypesWithArchived } from '../../modules/changeImpactTypes.js';

const mapStateToProps = (state) => ({
  changeImpactTypes: selectChangeImpactTypesWithArchived(state),
});

const ImpactTypeFilter = ({
  changeImpactTypes,
  selectedImpactTypes,
  navigateAction,
}) => {
  const selectedCount = selectedImpactTypes.length;

  const handleSelect = useCallback(
    (impactTypes) =>
      navigateAction({
        changeImpactTypeIds: impactTypes
          ? xor(selectedImpactTypes, [impactTypes])
          : [],
      }),
    [selectedImpactTypes]
  );

  const renderMenuItem = useCallback(
    (type) => {
      const isActive = selectedImpactTypes.includes(type.id);
      return (
        <React.Fragment key={type.key}>
          <MenuItem
            active={isActive}
            eventKey={type.id}
            onSelect={handleSelect}
          >
            <span
              className={`${type.archived && !isActive ? 'text-muted' : ''}`}
            >
              {type.name || ''} {type.archived ? '(archived)' : ''}
            </span>
          </MenuItem>
        </React.Fragment>
      );
    },
    [selectedImpactTypes]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">Impact Type</div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="impact-type-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {changeImpactTypes.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
};

ImpactTypeFilter.defaultProps = {
  selectedImpactTypes: [],
};

export default connect(mapStateToProps)(ImpactTypeFilter);
